import type { StagedStatus } from '../models/upload-in-progress-file';

/**
 * The staged files Convert may send (prod fixes 2026-10-02, PLAN.md C6): every file except one whose
 * `stagedStatus.kind` is `blocked` (FIX-6's "Can't convert"). The rest of a batch still converts.
 *
 * With no blocked row -- every row today -- it returns the SAME array, untouched (holes included), so the
 * caller's behaviour is exactly what it was.
 */
export function convertEligible<T extends { stagedStatus?: StagedStatus | null } | null | undefined>(files: T[]): T[] {
    if (!Array.isArray(files) || !files.some(isBlocked)) return files;
    return files.filter(f => !isBlocked(f));
}

export function isBlocked(file: { stagedStatus?: StagedStatus | null } | null | undefined): boolean {
    return file?.stagedStatus?.kind === 'blocked';
}
